import type { Connector } from '@particle-network/connector-core';
import { useSyncExternalStore } from 'react';
import { getConnectors } from '../actions/getConnectors';
import { watchConnectors } from '../actions/watchConnectors';
import { useContext } from '../context';

export const useConnectors = () => {
  const { config } = useContext();

  return useSyncExternalStore(
    (onChange) => watchConnectors(config, { onChange }),
    () => getConnectors(config),
    () => getConnectors(config)
  );
};

export function useConnector(id: string) {
  const connectors = useConnectors();
  return connectors.find((c) => c.id === id) as Connector;
}
